module.exports = __webpack_public_path__ + "8025949e36af1b2d846aa07368c3432b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/trevoQuina.svg
// module id = 363
// module chunks = 0